import type { RouteObject } from "react-router";

import type { RouteKey } from "../components/seo/RouteHead";
import { Layout } from "./_layout";
import { ActivityRoute } from "./activity";
import { AdminVerifyQueueRoute } from "./admin.verify";
import { AuthCallbackRoute } from "./auth.callback";
import { LoginRoute } from "./auth.login";
import { ChargersRoute } from "./chargers";
import { CommunityRoute } from "./community";
import { FavoritesRoute } from "./favorites";
import { HowToRoute } from "./how-to";
import { LandingRoute } from "./index";
import { PrivacyRoute } from "./privacy";
import { ProfileRoute } from "./profile";
import { RoutePlannerRoute } from "./route-planner";
import { SettingsRoute } from "./settings";
import { StationDetailRoute } from "./stations.$id";
import { NewStationRoute } from "./stations.new";
import { RequestStationRoute } from "./stations.request";

export type RouteHandle = {
  seo: RouteKey;
};

export const routes: RouteObject[] = [
  {
    path: "/",
    Component: Layout,
    children: [
      {
        index: true,
        Component: ChargersRoute,
        handle: { seo: "chargers" } satisfies RouteHandle,
      },
      {
        path: "route-planner",
        Component: RoutePlannerRoute,
        handle: { seo: "routePlanner" } satisfies RouteHandle,
      },
      {
        path: "home",
        Component: LandingRoute,
        handle: { seo: "home" } satisfies RouteHandle,
      },
      {
        // `/chargers` renders the same workspace as `/` so deep links and
        // share-URLs keep their pathname intact (a `redirect("/")` here
        // silently strips the path in history and analytics).
        path: "chargers",
        Component: ChargersRoute,
        handle: { seo: "chargers" } satisfies RouteHandle,
      },
      { path: "activity", Component: ActivityRoute, handle: { seo: "activity" } satisfies RouteHandle },
      { path: "community", Component: CommunityRoute, handle: { seo: "community" } satisfies RouteHandle },
      { path: "profile", Component: ProfileRoute, handle: { seo: "profile" } satisfies RouteHandle },
      { path: "stations/new", Component: NewStationRoute, handle: { seo: "stationNew" } satisfies RouteHandle },
      { path: "stations/request", Component: RequestStationRoute, handle: { seo: "stationRequest" } satisfies RouteHandle },
      { path: "stations/:id", Component: StationDetailRoute, handle: { seo: "stationDetail" } satisfies RouteHandle },
      { path: "favorites", Component: FavoritesRoute, handle: { seo: "favorites" } satisfies RouteHandle },
      { path: "auth/login", Component: LoginRoute, handle: { seo: "login" } satisfies RouteHandle },
      { path: "auth/callback", Component: AuthCallbackRoute, handle: { seo: "authCallback" } satisfies RouteHandle },
      { path: "settings", Component: SettingsRoute, handle: { seo: "settings" } satisfies RouteHandle },
      { path: "how-to", Component: HowToRoute, handle: { seo: "howTo" } satisfies RouteHandle },
      { path: "admin/verify", Component: AdminVerifyQueueRoute, handle: { seo: "adminVerify" } satisfies RouteHandle },
      { path: "privacy", Component: PrivacyRoute, handle: { seo: "privacy" } satisfies RouteHandle },
    ],
  },
];
